export const zones = [
    {
      bgColor: "#f7b815",
      text: [
        {
          title: "Parents zone",
          subtitle: "Ovo nije",
          text: "Ovo je mesto gde roditelji osećaju podršku i razumevanje od škole i ponos zbog onoga šta njihovo dete postaje.",
        },
        {
          title: "Prostor za partnerstvo i saradnju s roditeljima.",
          text: <>U prirodnim materijalima i sa pažljivo odabranim nameštajem, ova zona predstavlja prostor za prijem i razgovor sa roditeljima. <br/><br/>To je mesto gde škola i porodica grade međusobno razumevanje i postavljaju temelje zajedničke brige o razvoju deteta.</>,
          list: ["90 m²", "aktivna zona", "kolektivno"]
        },
      ],
    },
    {
      bgColor: "#9d1516",
      text: [
        {
          title: "Exploration zone",
          subtitle: "Ovo nije",
          text: "Ovo je mesto gde je nastala ideja koja je završila na školskom takmičenju. I postala StartUp godine koji je zaradio prvi million.",
        },
        {
          title: "Miran prostor fokusiran na rad, čitanje i istraživanje",
          text: <>Jasno definisana zona koja podstiče istraživanje, koncentraciju i individualni razvoj, a direktno je povezana sa muzičkom zonom i zonom sedenja, čime se omogućava prirodan prelaz između različitih vrsta aktivnosti – od tihog rada do otvorene razmene ideja.<br/><br/>Prostor je opremljen udobnim elementima za sedenje, što doprinosi fleksibilnosti u učenju i radu na projektima.</>,
          list: ["36 m²", "tiha zona", <>individualno / <br />u malim grupama</>]
        },
      ],
     
    },
    {
      bgColor: "#2b446b",
      text: [
        {
          title: "Learning zone",
          subtitle: "Ovo nije",
          text: "Ovo je mesto gde je neko samo uz jedno „zašto” pokrenulo debatu koja je mu je promenila život.",
        },
        {
          title: "Savremene učionice prilagođene stvarnim potrebama učenika",
          text: <>Obuhvata moderno opremljene učionice koje kombinuju funkcionalnost i tehničku podršku za savremenu nastavu. Fleksibilan raspored, ergonomski nameštaj i digitalni alati omogućavaju nastavnicima i učenicima dinamičan rad i lakše prilagođavanje različitim stilovima učenja.<br/><br/> Ovakvo okruženje podstiče aktivno učešće, bolju koncentraciju i efikasnije usvajanje znanja – u skladu sa zahtevima savremenog obrazovanja. </>,
          list: [<>126 m² / <br />16 učionica</>, "aktivna zona", <>
            individualno / <br />u malim grupama
          </>]
        },
      ],
    },
    {
      bgColor: "#427042",
      text: [
        {
          title: "STE(A)M zone",
          subtitle: "Ovo nije",
          text: "Ovo je mesto gde je neko prvi put video građu tkiva pod mikroskopom. I odlučio da će zauvek nositi beli mantil.",
        },
        {
          title: "Naučno-tehnološka zona za praktičan rad i istraživanje",
          text: <>Savremeni naučno-tehnološki hub škole, namenjen razvoju praktičnih veština kroz analitički i projektno orijentisan rad. Prostor je opremljen digitalnim alatima, tehničkom opremom i nastavnim sredstvima koji omogućavaju učenicima da istražuju, testiraju i stvaraju.<br/><br/>Kroz rad na konkretnim izazovima, učenici razvijaju logičko razmišljanje, preciznost i sigurnost u pronalaženju rešenja – to su veštine koje direktno vode ka uspehu u tehnološkom i akademskom svetu.</>,
          list: ["42 m²", "interaktivna zona", <>u grupama / <br />kolektivno</>]
        },
      ],
    }
  ];